import { useState, useEffect, useRef } from "react";
import APIUrls from "../../../services/APIUrls";
import { getAxiosResponse, postAxiosResponse, putAxiosResponse, } from "../../../services/authApiRoutes/APImethods";
import { Link, useParams, useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import ReactMultiSelect from "../../global/ReactMultiSelect";
import $ from "jquery";
import { useSelector } from "react-redux";
import Select from "react-select";
import Constants from "../../../Constants";
import CustomTaskForm from "./CustomTaskForm";
import { compareDateWithCurrent, dateFormat, dateFormatAccToTimeZone, dateFormatAndStatus, getHTMLfromText, transformBlankToNull } from "../../../services/Util";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import EditCustomTaskForm from "../../project/projectDetail/EditCustomTaskForm";
import { useForm } from "react-hook-form";
import axios from "axios";
import CustomProgressBar from "../../global/CustomProgressBar";
import DateFormat from "../../../pages/DateFormat";
import dateUtil from "../../../services/DateUtil";
import DateUtil from "../../../services/DateUtil";

export default function Tasks(prop) {
  const chunkSize = Constants.CHUNK_SIZE;
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const filterRef = useRef(null);
  const selectRef = useRef(null);
  const firstSelect = useRef(null);
  const filterButton = useRef(null);
  const multiSelectRef = useRef(null);
  const [totalRows, setTotalRows] = useState(0);
  const [selectedProjectStatus, setProjectStatus] = useState("");
  const [selectedTaskStatus, setTaskStatus] = useState("");
  const [selectedTypeStatus, setTypeStatus] = useState("");
  const [selectedAssignee, setAssignee] = useState("");
  const [selectedLanguages, setLanguage] = useState([]);
  const [selectedLanguagesString, setLanguageSting] = useState("");
  const [perPage, setPerPage] = useState(10);
  const [displayFilter, toggleDisplayFilter] = useState(false);
  const [tasks, setTasks] = useState([]);
  const [type, setType] = useState([]);
  const [projectFilter, setProjectFilter] = useState([]);
  const [languageFilter, setLanguageFilter] = useState([]);
  //task Details
  const [showTaskDetial, setShowTaskDetail] = useState(false);
  const [showTaskEdit, setShowTaskEdit] = useState(false);
  const [taskDetail, setTaskDetail] = useState({});
  const [taskFollowers, setTaskFollowers] = useState([]);
  const [recentTaskActivity, setRecentTaskActivity] = useState("");
  const [historyPopup, toggleHistoryPopup] = useState(false);
  const [selectedfile, setSelectedFile] = useState("");
  const [currentChunkIndex, setCurrentChunkIndex] = useState(null);
  const [fileUploadProgress, setFileUploadProgress] = useState(0);
  const [message, setMessage] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [documentFieldId, setDocumentFileId] = useState(-1);
  const langs = [];
  const [isFileAttached, setIsFileAttached] = useState(false);
  const [assignees, setAssigneeFilter] = useState([]);
  const [pending, setPending] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [sort, setSort] = useState("");
  const [error, setErrors] = useState("");
  const paginationRef = useRef();
  const { filterData, campaignWorkspace, activityTaskId } = prop;
  const [fileSizeExceedStatus,setFileSizeExceedStatus]=useState(false)
  const [taskStatusSortClicked, setTaskStatusSortClicked] = useState(false);
  const [taskNameSortClicked, setTaskNameSortClicked] = useState(false);
  const [taskDueDateSortClicked, setTaskDueDateSortClicked] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const filterToggle = () => {
    displayFilter ? toggleDisplayFilter(false) : toggleDisplayFilter(true);
    $("#activeId").toggleClass("clickActive");
    $(document).mouseup(function (e) {
      var bannerCont = $(".btn-wrap");
      if (!bannerCont.is(e.target) && bannerCont.has(e.target).length === 0) {
        toggleDisplayFilter(false);
        $(".clickActive").trigger("focus");
        $("#activeId").removeClass("clickActive");
      }
    });
  };
  const handleEscFocus = (event) => {
    if (
      event.key === Constants.ESCAPE &&
      event.target.ariaExpanded === "true"
    ) {
      toggleDisplayFilter(false);
      $("#activeId").trigger("focus");
      $("#activeId").removeClass("clickActive");
    }
  };
  const handleModalFocus = (event) => {
    if (
      event.key === Constants.ESCAPE &&
      event.target.ariaExpanded === "false"
    ) {
      toggleDisplayFilter(false);
      $("#activeId").trigger("focus");
      $("#activeId").removeClass("clickActive");
    }
    if (event.target.ariaLabel === "Language") {
      if (event.key === Constants.TAB && !event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId").trigger("focus");
      }
    }
    if (event.target.ariaLabel === "Project") {
      if (event.key === Constants.TAB && event.shiftKey) {
        event.preventDefault();
        toggleDisplayFilter(false);
        $("#activeId").trigger("focus");
      }
    }
  };
  useEffect(() => {
    if (displayFilter) {
      $(".local-filter").css("display", "block");
      $("#activeId").attr("aria-expanded", "true");
    } else {
      $(".local-filter").css("display", "none");
      $("#activeId").attr("aria-expanded", "false");
    }
  }, [displayFilter]);
  const custBootstrapDataRedux = useSelector(
    (store) => store.customer_bootstrap_data
  ).value;

  function showModel() {
    document.body.classList.add("modal-open");
  }

  useEffect(() => {
    if (tasks?.length > 0) {
      if (filterData !== null) {
        setTaskStatus(Constants.TASK_STATUS(filterData.status));
        setTypeStatus(Constants.REVIEW_STATUS);
        setAssignee(Constants.ASSIGNED_ID(filterData.assigneeId));
      }
    }
  }, [tasks]);

  const getTaskUrl = (task) => {
    var url = "/project";
    switch (task.type.originalEnum) {
      case "SELECT_WINNING_BID":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "bids" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );
      case "CONFIGURE_PROJECT_SOURCE":
        return (
          <Link onClick={(e) => navigate(`/project/${task.project.id}`)}>
            {task.displayName}
          </Link>
        );
      case "REVIEW_BID_DUE_DATE":
        return (
          <Link onClick={(e) => navigate(`/project/${task.project.id}`)}>
            {task.displayName}
          </Link>
        );

      case "CONFIGURE_PROJECT_WORKFLOW":
        return (
          <Link onClick={(e) => navigate(`/project/${task.project.id}`)}>
            {task.displayName}
          </Link>
        );
      case "RESPOND_TO_CUSTOMER_INTERNAL_PROJECT_REQUEST":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "internalTranslator" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_MACHINE_TRANSLATION_QUOTE":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "machineTranslation" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "RESPOND_TO_VENDOR_CHANGE_ORDER_BID":
        url = `/${task.url.substring(1)}`;
        var code = task?.url.split("/").pop();
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "changeOrder", id: code },
              });
            }}
          >
            {task.displayName}
          </Link>
        );
      case "RESPOND_TO_CUSTOMER_CHANGE_ORDER_REQUEST":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "changeOrder" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "CUSTOM":
        if (task.project !== "") {
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
                navigate(`/project/${task.project.id}`, {
                  state: { tab: "tasks" },
                });
              }}
            >
              {task.displayName}
            </Link>
          );
        } else {
          url = task.url.replace("#workspace", "/campaign");
          return (
            <Link
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {task.displayName}
            </Link>
          );
        }

      case "PROJECT_ACCEPT_CANCELLATION":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "bids" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "REVIEW_APPROVED_ASSET_NOTES":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "overView" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "REQUEST_BIDS_FOR_PROJECT":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`);
            }}
          >
      {translate(`campaign_tasks.${task.type.code}`)}
          </Link>
        );

      case "REVIEW_PROJECT_ASSETS":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "overView", langCode: task.language.code },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "DELIVER_PROJECT_ASSETS":
        if(task.language !== ''){
          code = task.language.code
        }else{
          code = task?.url.split("/").pop()
        }
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "overView", langCode: task.language.code },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "REVISE_PROJECT_ASSETS":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "overView", langCode: task.language.code },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "REVIEW_PROJECT_REQUEST":
        return (
          <Link
            onClick={(e) => {
              e.preventDefault();
              navigate(`/project/${task.project.id}`, {
                state: { tab: "overView" },
              });
            }}
          >
            {task.displayName}
          </Link>
        );

      case "ASSIGN_USERS_TO_GROUPS":
        return (
          <Link
            onClick={(e) => {
              navigate(`/settings/user-management`);
            }}
          >
            {task.displayName}
          </Link>
        );

      default:
        return <Link to="#">{task.displayName}</Link>;
    }
  };

  useEffect(() => {
    if (activityTaskId) {
      showTaskDetail(activityTaskId);
    }
  }, [activityTaskId]);

  const getTitle = (row) => {
    if (row.type.originalEnum === "CUSTOM") {
      return (
        <>
          <a
            style={{
              color: aaaSelected ? "#FFF" : "#4067D6",
              fontWeight: 500,
              position: "relative",
            }}
            onClick={(e) => showTaskDetail(row.id)}
          >
            {row.displayName}
          </a>
        </>
      );
    }
    $(document).ready(function () {
      $(".rdt_Table .rdt_TableCol span").attr("aria-hidden", "true");
      $(".rdt_TableCol .rdt_TableCol_Sortable[disabled]").attr(
        "tabIndex",
        "-1"
      );
      $(".rdt_Table").attr("aria-label", "Campaign Tasks");
      $(".rdt_Table input").parent().attr("role", "cell");
    });
    return getTaskUrl(row);
  };
  const handleSort = async (column, sortDirection) => {
    $(".rdt_TableCol_Sortable[data-column-id='" + column.id + "']").attr({
      "aria-label": column.name,
      "aria-sort":
        sortDirection.toUpperCase() === Constants.DESC
          ? Constants.DESCENDING
          : Constants.ASCENDING,
    });
   
    const order = sortDirection.toUpperCase();
    const sortedColumn = column.id;
    const sortedString = `&order=${order}&sort=${sortedColumn}`;
  
    setSort(sortedString);
    
    switch (column.id) {
      case "task.status":
        setTaskStatusSortClicked(prevState => !prevState);
        break;
      case "task.name":
        setTaskNameSortClicked(prevState => !prevState);
        break;
      case "task.dueDate":
        setTaskDueDateSortClicked(prevState => !prevState);
        break;
      default:
        break;
    }
  };
  const columns = [
    {
      id: "task.name",
      name: "Name",
      minWidth: "350px",
      selector: (row) => row.displayName,
      cell: (row) => getTitle(row),
    },
    {
      id: "task.project.name",
      name: "Project",
      selector: (row) => row.project.name,
      cell: (row) => <div>{row.project?.name}</div>,
    },
    {
      id: "task.taskCategoryDisplay",
      name: "Type",
      selector: (row) => row.taskCategoryDisplay,
      cell: (row) => <div>{row.taskCategoryDisplay}</div>,
    },
    {
      id: "task.assigneeUser",
      name: "Assigned To",
      selector: (row) => row.assigneeUser,
      cell: (row) => <div>{row.assigneeUserName}</div>,
    },
    {
      id: "task.assetType",
      name: "Language",
      selector: (row) => row?.language?.display,
      cell: (row) => <div>{row?.language?.display}</div>,
    },
    {
      id: "task.status",
      name: "Task Status",
      selector: (row) => row?.status?.display,
      cell: (row) => <div>{row.status?.display}</div>,
    },
    {
      id: "task.dueDate",
      name: "Due Date",      
      selector: (row) => row.dueDate,
      cell: (row, date) =>
        row.dueDate !== ""
          ? ((date = dateUtil.format(row.dueDate)),
            (
              <div className="relative">
                <span className="font-zero setFastpass">{date}</span>
                <span aria-hidden="true">
                  <DateFormat date={row.dueDate}/>
                </span>
                {row.status?.display !== "Closed" ? (
                  <span className="alert-text">
                    {dateFormatAndStatus(
                      row.dueDate,
                      "MM/DD/YY",
                      custBootstrapDataRedux.user?.timeZone
                    )[1] !== ""
                      ? "(" +
                        dateFormatAndStatus(
                          row.dueDate,
                          "MM/DD/YY",
                          custBootstrapDataRedux.user?.timeZone
                        )[1] +
                        ")"
                      : ""}
                  </span>
                ) : (
                  Constants.BLANK
                )}
              </div>
            ))
          : "",
    },
  ];

  const [showCreateTask, toggleCreateTask] = useState(false);
  const param = useParams();
  const workspaceId = param.id;

  const toogleFromList = (val) => {
    toggleCreateTask(val);
  };

  const conctString = (taskTypes) => {
    var taskTypeString = "";
    taskTypes.map((taskType, index) => {
      taskTypeString += `&type=${taskType.originalEnum}`;
    });
    return taskTypeString;
  };
  const projectArray = [];
  const taskArray = [];
  const assignieeArray = [];
  const languageArray = [
    {
      label: translate("task_campaign.check_all"),
      value: "all",
    },
    {
      label: translate("task_campaign.uncheck_all"),
      value: "none",
    },
  ];
  useEffect(() => {
    getAxiosResponse(APIUrls.CAMPAIGN_TASK_PROJECT_FILTER_VALUES(workspaceId))
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((project) => {
            projectArray.push({
              label: project.name,
              value: "&pId=" + project.id,
            });
          });
        }
        const projectArrayWithSelect = [
          { label: translate("task_campaign.select"), value: "" },
          ...projectArray,
        ];
        setProjectFilter(projectArrayWithSelect);
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
      });

    getAxiosResponse(
      APIUrls.ALL_TASK_TYPES + "?entityType=PROJECT&entityType=WORKSPACE"
    )
      .then((res) => {
        if (res.data !== "") {
          res.data.data.result.map((task) => {
            taskArray.push({
              label: translate("task_campaign." + task.code.toLowerCase()),
              value: conctString(task.taskTypes),
            });
          });
        }
        const taskArrayWithSelect = [
          { label: translate("task_campaign.select"), value: "" },
          ...taskArray,
        ];
        setType(taskArrayWithSelect);
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
      });
    getAxiosResponse(APIUrls.CAMPAIGN_ASSIGNED_TO_LIST)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((assignee) => {
            assignieeArray.push({
              label: assignee.firstName + " " + assignee.lastName,
              value: "&assigneeId=" + assignee.userId,
            });
          });
        }
        const assigneeArrayWithSelect = [
          { label: translate("task_campaign.select"), value: "" },
          ...assignieeArray,
        ];
        setAssigneeFilter(assigneeArrayWithSelect);
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
      });
    getAxiosResponse(APIUrls.CAMPAIGN_LANGUAGE_FILTER_VALUES(workspaceId))
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((language) => {
            languageArray.push({
              label: language.display,
              value: "&langs=" + language.code,
              name: language?.name,
            });
          });
        }

        if (languageFilter.length == 0) {
          setLanguageFilter(languageArray);
        }
        setPending(false);
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);
  const taskStatus = [
    { label: translate("task_campaign.select"), value: "" },
    { label: translate("task_campaign.open"), value: "&status=OPEN" },
    { label: translate("task_campaign.completed"), value: "&status=CLOSED" },
    { label: translate("task_campaign.rejected"), value: "&status=REJECTED" },
    { label: translate("task_campaign.cancelled"), value: "&status=CANCELLED" },
  ];

  const handlePageChange = (paging) => {
    setPending(true);
    setCurrentPage(paging);
    if ($("#pagination-last-page").attr("aria-disabled") === "true") {
      paginationRef.current = $("#pagination-previous-page").attr("id");
    } else if ($("#pagination-first-page").attr("aria-disabled") === "true") {
      paginationRef.current = $("#pagination-next-page").attr("id");
    } else {
      paginationRef.current = document.activeElement.id;
    }
  };

  const fetchTaskData = async (page) => {
    setPending(true);
    await getAxiosResponse(
      APIUrls.ALL_TASKS +
        `?wId=${workspaceId}&pageSize=${perPage}&page=${page}${sort}&onlyFollowed=false${selectedTaskStatus}${selectedProjectStatus}${selectedTypeStatus}${selectedAssignee}${selectedLanguagesString}`
    )
      .then((res) => {
        if (res.data !== "") {
          let taskCampaign = res?.data?.data?.result;
          if (taskCampaign && taskCampaign.length) {
            const finalTasks = taskCampaign.map((data) => {
              if (data?.status?.display === "Closed") {
                return {
                  ...data,
                  status: {
                    display: "Completed",
                    code: "completed",
                    originalEnum: "COMPLETED",
                  },
                };
              }
              return data;
            });
            setTasks(finalTasks);
            setTotalRows(res.data.data.resultCount);          
          } else {
            setTasks([]);
            setTotalRows(res.data.data.resultCount);
          }
          setTimeout(() => {
            if (paginationRef.current) {
              $("#" + paginationRef.current).trigger("focus");
              paginationRef.current = "";
            }
          }, 300);
        } else {
          setTasks([]);
        }
      })
      .catch((err) => {
        console.error(err);
      });

    setPending(false);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    setPending(true);
    await getAxiosResponse(
      APIUrls.ALL_TASKS +
        `?wId=${workspaceId}&page=${page}&pageSize=${newPerPage}${sort}&onlyFollowed=false${selectedProjectStatus}${selectedTaskStatus}${selectedTypeStatus}${selectedAssignee}${selectedLanguagesString}`
    )
      .then((res) => {
        if (res.data !== "") {
          let taskCampaign = res?.data?.data?.result;
          if (taskCampaign && taskCampaign.length) {
            const finalTasks = taskCampaign.map((data) => {
              if (data?.status?.display === "Closed") {
                return {
                  ...data,
                  status: {
                    display: "Completed",
                    code: "completed",
                    originalEnum: "COMPLETED",
                  },
                };
              }
              return data;
            });
            setTasks(finalTasks);
            setTotalRows(res.data.data.resultCount);
          }
          setPerPage(newPerPage);
          setPending(false);
          setTimeout(function () {
            $(".datatable-block")
              .find(".rdt_Pagination select")
              .trigger("focus");
          }, 100);
        }
      })
      .catch((err) => {
        console.error(err);
      });
    setPending(false);
  };

  const handleProjectStatusChange = (event) => {
    var selectedStatus = event.value;
    setProjectStatus(selectedStatus);
  };
  const handleTaskStatusChange = (event) => {
    var selectedTaskStatus = event.value;
    setTaskStatus(selectedTaskStatus);
  };
  const handleTypeStatusChange = (event) => {
    var selectedTypeStatus = event.value;
    setTypeStatus(selectedTypeStatus);
  };
  const handleAssigneeChange = (event) => {
    var selectedAssignee = event.value;
    setAssignee(selectedAssignee);
  };
  const handleLanguageChange = (value) => {
    var str = ``;
    setLanguage(value);
    var selectedLang = value;
    selectedLang.map((values) => {
      str += values.value;
    });
    setLanguageSting(str);
    setTimeout(function () {
      multiSelectRef.current.focus();
    }, 2000);
  };

  useEffect(() => {
    fetchTaskData(currentPage);
  }, [
    sort,
    currentPage,
    selectedProjectStatus,
    selectedTaskStatus,
    selectedTypeStatus,
    selectedAssignee,
    selectedLanguagesString,
    showCreateTask,
    taskStatusSortClicked,
    taskNameSortClicked,
    taskDueDateSortClicked
  ]);

  const noDataFoundComponent = () => {
    return (
      <div role="rowgroup">
        <div role="row" className="no-data-display align-center">
          <div role="cell">
            <i className="nodata-icon"></i>
            <p>{Constants.NO_DATA_FOUND}</p>
          </div>
        </div>
      </div>
    );
  };

  const handleInputChange = (e) => {
    if (e.length > 0) {
      $("#selected-lang-container").addClass("display-none");
    } else {
      $("#selected-lang-container").removeClass("display-none");
    }
  };

  const showTaskDetail = (id) => {
    getAxiosResponse(APIUrls.TASK_BY_ID(id))
      .then((res) => {
        setTaskDetail(res.data.data);
        setShowTaskDetail(true);
        setShowTaskEdit(false);
      })
      .catch((err) => {
        console.error(err);
      });
    getFollowers(id);
  };

  const getFollowers = (id) => {
    // getAxiosResponse(
    //   APIUrls.GET_MOST_RECENT_ACTIVITY_BY_TASK(workspaceId, id)
    // ).then((res) => {
    //   setRecentTaskActivity(res.data.data);
    // });
    getAxiosResponse(APIUrls.GET_TASK_FOLLOWERS(id))
      .then((res) => {
        setTaskFollowers(res.data.data);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getTaskFollowButtonState = () => {
    // There are three states we care about here:
    // ADD_FOLLOWER: the user is neither a follower nor the assignee, show the "add follower" button
    // NO_BUTTON: the user is a vendor, or the user is the assignee, so they must remain a follower; show no button
    // REMOVE_FOLLOWER: the user is a follower, show the "remove follower" button
    // if (custBootstrapDataRedux.roleSet.customerType && (!projectData || projectData.userCanAlterProject) && (!taskDetail.workspace !== "" || projectData.workspace.editableByContextUser)) {
    //   var contextId = custBootstrapDataRedux.user.userId;
    //   if (
    //     taskDetail.assigneeUser !== "" &&
    //     taskDetail.assigneeUser.userId === contextId
    //   ) {
    //     return "NO_BUTTON";
    //   }
    // } else {
    //   return "NO_BUTTON";
    // }
    var contextId = custBootstrapDataRedux.user.userId;
    if (taskFollowers.length > 0) {
      var inFollowers = false;
      var countCustomerUser = 0;
      taskFollowers.map((follower) => {
        if (follower.customerUser) {
          countCustomerUser++;
          if (follower.customerUser.userId === contextId) {
            inFollowers = true;
          }
        }
      }, this);
      if (inFollowers) {
        if (countCustomerUser > 1) {
          return "REMOVE_FOLLOWER";
        } else {
          return "NO_BUTTON";
        }
      }
    }
    return "ADD_FOLLOWER";
  };

  const editTask = (status) => {
    setShowTaskEdit(status);
    setShowTaskDetail(false);
  };

  const showRecentActivity = () => {
    toggleHistoryPopup(true);
    showModel();
  };

  const addRemoveMe = () => {
    var copyTaskDetail = structuredClone(taskDetail);
    copyTaskDetail.pending = false;
    copyTaskDetail = DateUtil.dateTimestampObjectTransformation(copyTaskDetail, ["createdDate"]);
    var payload = transformBlankToNull(copyTaskDetail);
    putAxiosResponse(APIUrls.UPDATE_TASK_FOLLOWERS(taskDetail.id), payload)
      .then((res) => {
        getFollowers(taskDetail.id);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const downloadAttachment = (commentId) => {};

  const fileSelection = (e) => {
    if (e.target) {
      setSelectedFile(e.target.files[0]);
      setFileUploadProgress(0);
      const fileSizeInBytes = e?.target?.files[0]?.size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024);
      if (fileSizeInMB > 50) {
       setFileSizeExceedStatus(true)
     } else {
       setFileSizeExceedStatus(false)
     }
   
    }
  };

  const postMsg = () => {
    document.getElementById("msg-content").value = "";
    const params = new URLSearchParams();
    if (selectedfile === "") {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", true);
      params.set("documentFileId", "");
    }

    const urlWithParams = `${APIUrls.TASK_DISCUSSION_ATTACHMENT_META(
      taskDetail.id
    )}?${params.toString()}`;
    postAxiosResponse(urlWithParams)
      .then((res) => {
        let error=res?.data?.result?.errors?.general_exception_key
        if(error){
          setErrors(error)
          return
        }else{
          setDocumentFileId(res.data.documentFileId);
          setCurrentChunkIndex(0);
          setIsFileAttached(false);          
        }
      })
      .catch((err) => {
        console.error(err);
        setIsFileAttached(false);
      });
  };

  useEffect(() => {
    if (currentChunkIndex !== null) {
      setShowProgress(true);
      readAndUploadCurrentChunk();
    }
  }, [currentChunkIndex]);

  const readAndUploadCurrentChunk = () => {
    const file = selectedfile;
    if (file) {
      const reader = new FileReader();
      const from = currentChunkIndex * chunkSize;
      const to = from + chunkSize;
      const blob = file.slice(from, to);
      reader.onload = (e) => uploadChunk(e);
      reader.readAsDataURL(blob);
    } else {
      uploadChunk(null);
    }
  };

  const uploadChunk = (readerEvent) => {
    const file = selectedfile;
    const data = readerEvent ? readerEvent.target.result : {};
    const headers = {
      "Content-Type": "application/octet-stream",
      "CSRF-Token": localStorage.getItem("csrfToken"),
    };
    let params = getMetadataParams();
    var urlPart = "";
    if (file) {
      urlPart =
        APIUrls.TASK_DISCUSSION_ATTACHMENT(taskDetail.id) +
        `?${params.toString()}`;
    } else {
      urlPart =
        APIUrls.TASK_DISCUSSION_ATTACHMENT(taskDetail.id).replace(
          "/upload",
          ""
        ) + `?${params.toString()}`;
    }
    const url = `${process.env.REACT_APP_BACKEND_SERVER}${urlPart}`;
    axios
      .post(url, data, { headers })
      .then((response) => {
        if (selectedfile !== "") {
          const filesize = selectedfile.size;
          const chunks = Math.ceil(filesize / chunkSize) - 1;
          const isLastChunk = currentChunkIndex === chunks;
          if (isLastChunk) {
            setCurrentChunkIndex(null);
            setFileUploadProgress(100);
            setIsFileAttached(false);
            // getData()
            setSelectedFile("");
            showTaskDetail(taskDetail.id);
          } else {
            const chunks = Math.ceil(filesize / chunkSize);
            setFileUploadProgress(
              Math.round((currentChunkIndex / chunks) * 100)
            );
            setCurrentChunkIndex(currentChunkIndex + 1);
          }
        } else {
          setCurrentChunkIndex(null);
          showTaskDetail(taskDetail.id);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const getMetadataParams = () => {
    const params = new URLSearchParams();

    if (selectedfile === "") {
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", false);
      params.set("documentFileId", "");
    } else {
      params.set("name", selectedfile.name);
      params.set("size", selectedfile.size);
      params.set("currentChunkIndex", currentChunkIndex);
      params.set("totalChunks", Math.ceil(selectedfile.size / chunkSize));
      params.set("text", message);
      params.set("taskId", taskDetail.id);
      params.set("hasDocument", true);
      params.set("fileDataAttribute", "attachment.fileData");
      params.set(
        "documentFileId",
        documentFieldId !== -1 ? documentFieldId : ""
      );
    }

    return params;
  };

  const validations = {
    message: {
      required: "Message is required",
      maxLength: {
        value: 3500,
        message: "Message must be 3500 characters long",
      },
    },
  };

  const formatBytes = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";
    const k = 1024;
    let dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
    let i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
  };

  const cancelChat = () => {};

  function hideModel() {
    document.body.classList.remove("modal-open");
  }

  return (
    <>
      <div className="listing-content">
        {showTaskDetial ? (
          <>
            <div>
              <div className="translate-heading">
                <div className="name-card-section p-0">
                  <div className="name-card-section-left">
                    <div className="campaign-name">
                      <button
                        onClick={() => setShowTaskDetail(false)}
                        className="back-btn"
                        aria-label="back-arr"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                        >
                          <path
                            d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                            fill="#4D4D4D"
                          />
                        </svg>
                      </button>
                      <h3>Back to All Campaign Tasks</h3>
                    </div>
                  </div>
                  <div className="name-card-section-right"></div>
                </div>
                <div className="campaign-name">
                  <h3>{taskDetail?.displayName}</h3>
                  <button
                    aria-label="Edit"
                    className="name-edit"
                    onClick={() => editTask(true)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="17"
                      viewBox="0 0 18 17"
                      fill="none"
                    >
                      <path
                        d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                        fill="#1D4ED8"
                      ></path>
                    </svg>
                  </button>
                </div>

                <p>
                  <b>Created by : </b>
                  {taskDetail?.creatorName + " on " + taskDetail?.createdDate?.date}
                </p>
                <p>
                  <b>Descrioption : </b>
                  {getHTMLfromText(taskDetail?.description)}
                </p>
              </div>
              <div className="campaign_details-task campaign-form">
                <div className="projects-heading"></div>

                <div className="projects-contents">
                  <div className="table-responsive global-table">
                    <table className="sortable mar-bot20">
                      <thead>
                        <tr>
                          <th>Assigned to</th>
                          {taskDetail?.startDate !== "" ? (
                            <th>Start Date</th>
                          ) : ( "" )}
                          {taskDetail?.dueDate !== "" ? <th>Due Date</th> : ""}
                          <th>Task Status</th>
                          <th>Task History</th>
                          {custBootstrapDataRedux?.roleSet?.vendorType ? (
                            <th>
                              Who will receive notifications about this task?
                            </th>
                          ) : taskFollowers?.length > 0 ? (
                            <th>
                              Who will receive notifications about this task?
                            </th>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{taskDetail?.assigneeUserName}</td>
                          {taskDetail?.startDate !== "" ? (
                            <td> {taskDetail?.startDate?.date} </td>
                          ) : ( "" )}
                          {taskDetail?.dueDate !== "" ? (
                            <td> {taskDetail?.dueDate?.date} </td>
                          ) : ( "" )}
                          <td>
                            <b>{taskDetail?.status?.display}</b>
                          </td>
                          <td>
                            <Link onClick={() => showRecentActivity()}>
                              View
                            </Link>
                          </td>
                          {custBootstrapDataRedux.roleSet.vendorType ? (
                            taskDetail.visibleToCustomer ? (
                              <td>Customer ,Vendor</td>
                            ) : (
                              <td>Vendor</td>
                            )
                          ) : taskFollowers?.length > 0 ? (
                            <td>
                              {taskFollowers?.map((follower, index) => {
                                return follower.customerUser ? (
                                  taskFollowers?.length > index + 1 ? (
                                    <span key={index}>
                                      {follower.customerUser.firstName +
                                        " " +
                                        follower.customerUser.lastName}{" "}
                                      ,{" "}
                                    </span>
                                  ) : (
                                    <span key={index}>
                                      {" "}
                                      {follower.customerUser.firstName +
                                        " " +
                                        follower.customerUser.lastName}
                                    </span>
                                  )
                                ) : follower.vendor ? (
                                  follower.vendor.name
                                ) : null;
                              })}{" "}
                              {getTaskFollowButtonState() === "ADD_FOLLOWER" ? (
                                <Link onClick={() => addRemoveMe()}>
                                  Add me
                                </Link>
                              ) : getTaskFollowButtonState() ===
                                "REMOVE_FOLLOWER" ? (
                                <Link onClick={() => addRemoveMe()}>
                                  Remove me
                                </Link>
                              ) : null}
                            </td>
                          ) : null}
                        </tr>
                        <tr>{!taskDetail?.isWorkflowTask}</tr>
                      </tbody>
                    </table>
                    <table className="sortable  mar-bot20">
                      <thead>
                        <tr>
                          {!taskDetail?.isWorkflowTask ? (
                            <th className="align-left">Closed Date</th>
                          ) : (
                            ""
                          )}
                          {taskDetail?.targetLanguage !== "" ? (
                            <th>Language</th>
                          ) : (
                            ""
                          )}
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          {!taskDetail?.isWorkflowTask ? (
                            taskDetail?.closedDate !== "" ? (
                              <td className="align-left">
                                {dateFormat(
                                  taskDetail?.startDate,
                                  Constants.DATE_HOUR_YEAR_MIN_SEC
                                )}{" "}
                              </td>
                            ) : (
                              <td className="align-left">N/A</td>
                            )
                          ) : (
                            ""
                          )}
                          {taskDetail?.targetLanguage !== "" ? (
                            <td className="align-left">{taskDetail?.targetLanguage}</td>
                          ) : (
                            ""
                          )}
                        </tr>
                      </tbody>
                    </table>
                    {/* <div className="no-data-display align-center">
                    <i className="nodata-icon"></i>
                    <p>Currently there are no change orders.</p>
                  </div> */}
                  </div>
                </div>
              </div>
              <h5 className="heading-width-border mar-bot30">Discussion</h5>
              <div className="table-responsive">
                <table className="sortable">
                  <tbody>
                    {taskDetail?.comments?.length > 0 ? (
                      taskDetail?.comments?.map((comment, index) => {
                        return (
                          <tr key={index}>
                            <td>{comment?.creatorDisplayName}</td>
                            <td>
                              {comment?.createdDate?.date + " " + comment?.createdDate?.timeOfDay}
                            </td>
                            <td>
                              <strong>{getHTMLfromText(comment?.text)}</strong>
                            </td>
                            {comment.attachment !== "" ? (
                              <td>
                                <Link
                                  onClick={() => downloadAttachment(comment.id)}
                                >
                                  {comment.attachment.filename}
                                </Link>
                              </td>
                            ) : (
                              <td></td>
                            )}
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        {/* <td></td> */}
                        <td className="p-0 bgTransparent">
                          <p>
                            No one has discussed this request yet. When someone
                            does, it will show here.
                          </p>
                        </td>
                      </tr>
                    )}
                    <tr>
                      {/* <td className="pl-0 pr-0"></td> */}
                      {/* <td></td>
                      <td></td> */}
                      {taskDetail?.status?.display !== "Closed" &&
                      taskDetail?.status?.display !== "Rejected" ? (
                        <td colSpan="4" className="pl-0 pr-0 bgTransparent">
                          <div className="flex create-task-discussion">
                            <div className="left-uname">
                              <p>{custBootstrapDataRedux?.user?.firstName + " "+ custBootstrapDataRedux?.user?.lastName}</p>
                            </div>
                            <div className="campaign_details-task-create-form discussion-form">
                              <div className="projects-heading">
                                <h5>Comments</h5>
                              </div>
                              <form onSubmit={handleSubmit(postMsg)}>
                                <div className="task-form-content">
                                  <div className="form-group text">
                                    <div className="form-text">
                                      <label>Message </label>
                                      <textarea
                                        className="textarea"
                                        id="msg-content"
                                        placeholder="3500 characters limit"
                                        maxLength={3500}
                                        {...register(
                                          "message",
                                          validations.message
                                        )}
                                        onChange={(event) =>
                                          setMessage(event.target.value)
                                        }
                                      ></textarea>
                                      <p
                                        className="error textDanger m-0"
                                        aria-label="error alert"
                                        role="alert"
                                      >
                                        {errors.message?.message}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex wrap-dropdown file-btn">
                                    {error !=="" && <span className="textDanger">{error}</span>}
                                    {fileSizeExceedStatus ? <p className="textDanger">File size exceeds 50MB.</p>:Constants.BLANK}
                                    <div className="file-input flex w-d100">
                                      {!isFileAttached ? (
                                        <div className="input-file mar-bot16">
                                          <input
                                            type="file"
                                            id="files"
                                            onChange={fileSelection}
                                          />
                                          <label
                                            className="file-button flex-center"
                                            htmlFor="files"
                                          >
                                            {!selectedfile
                                              ? "Choose file"
                                              : "Select a different file"}
                                          </label>
                                        </div>
                                      ) : (
                                        Constants.BLANK
                                      )}
                                      <div
                                        className={
                                          selectedfile
                                            ? "uploading-files-block uploading-success w-d100"
                                            : "uploading-files-block uploading-success w-d100 hide"
                                        }
                                      >
                                        <div className="uploading-file-list flex">
                                          <div className="left-file-desc flex-center">
                                            <div className="icon-block">
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="25"
                                                height="25"
                                                viewBox="0 0 25 25"
                                                fill="none"
                                              >
                                                <path
                                                  d="M19.3612 24.1735H5.63886C4.72272 24.1723 3.84447 23.8078 3.19673 23.1599C2.54899 22.5121 2.18464 21.6338 2.18359 20.7176V4.28144C2.18481 3.36542 2.54924 2.48727 3.19696 1.83955C3.84469 1.19182 4.72284 0.827397 5.63886 0.826178H14.402C14.8572 0.825314 15.3081 0.914634 15.7286 1.08898C16.1491 1.26333 16.531 1.51925 16.852 1.84197L21.8 6.78539C22.4488 7.43731 22.8141 8.31894 22.8165 9.23868V20.7176C22.8154 21.6338 22.4511 22.5121 21.8034 23.1599C21.1556 23.8078 20.2774 24.1723 19.3612 24.1735ZM5.63886 2.47091C5.15889 2.47161 4.69878 2.66259 4.35939 3.00197C4.02 3.34136 3.82903 3.80147 3.82833 4.28144V20.7176C3.82903 21.1977 4.01998 21.6578 4.35935 21.9973C4.69872 22.3368 5.15883 22.5279 5.63886 22.5288H19.3612C19.8413 22.5279 20.3014 22.3368 20.6407 21.9973C20.9801 21.6578 21.1711 21.1977 21.1717 20.7176V9.2367C21.1706 8.75346 20.9786 8.29024 20.6375 7.94789L15.6895 3.00447C15.5208 2.83483 15.3202 2.70033 15.0992 2.60874C14.8782 2.51716 14.6412 2.47031 14.402 2.47091H5.63886Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M21.2624 9.02539H18.1999C17.2868 9.02452 16.4113 8.66138 15.7656 8.01568C15.1199 7.36998 14.7567 6.49447 14.7559 5.58131V1.65039H16.4006V5.58131C16.4011 6.05837 16.5909 6.51573 16.9282 6.85306C17.2655 7.19039 17.7229 7.38013 18.1999 7.38065H21.2624V9.02539Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M9.09858 16.2195C9.0335 16.2177 8.96983 16.2001 8.91305 16.1682C8.84727 16.134 8.77753 16.0958 8.70319 16.0537L6.1374 14.5458C6.07628 14.5057 6.02717 14.4498 5.99529 14.384C5.96422 14.3214 5.94779 14.2525 5.94727 14.1827C5.94722 14.1102 5.96364 14.0387 5.99529 13.9735C6.02596 13.9088 6.07551 13.8549 6.1374 13.8189L8.70319 12.3432C8.76483 12.3046 8.82978 12.2716 8.89727 12.2445C8.95114 12.2222 9.0087 12.2101 9.067 12.209C9.12446 12.2118 9.18064 12.2269 9.23173 12.2534C9.28281 12.2798 9.32761 12.317 9.36305 12.3623C9.44775 12.4479 9.49708 12.5623 9.50121 12.6827C9.50051 12.737 9.48529 12.7902 9.45713 12.8366C9.42521 12.891 9.37991 12.9363 9.32555 12.9682L6.58608 14.5557L6.53082 13.7662L9.31766 15.4327C9.37448 15.4644 9.42036 15.5125 9.44924 15.5708C9.475 15.6235 9.48849 15.6813 9.48871 15.7399C9.48922 15.8646 9.44217 15.9849 9.35713 16.0761C9.32648 16.1168 9.28762 16.1505 9.24308 16.1752C9.19855 16.2 9.14932 16.215 9.09858 16.2195Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M9.09903 16.3842C9.00676 16.3829 8.91629 16.3585 8.83588 16.3132C8.77009 16.2796 8.69772 16.2401 8.6214 16.1967L6.05232 14.6882C5.96296 14.631 5.89121 14.5502 5.84509 14.4546C5.80286 14.3702 5.78036 14.2773 5.7793 14.1829C5.78005 14.0858 5.80253 13.99 5.84509 13.9026C5.88955 13.8086 5.96161 13.7304 6.05167 13.6783L8.61745 12.2007C8.68592 12.1578 8.75815 12.1212 8.83324 12.0915C8.94371 12.0425 9.06734 12.0318 9.18457 12.061C9.30181 12.0902 9.40598 12.1576 9.48061 12.2526C9.5932 12.368 9.65785 12.5218 9.66153 12.6829C9.6609 12.7661 9.6382 12.8476 9.59574 12.9191C9.55045 12.9955 9.48693 13.0594 9.41088 13.1053L7.55496 14.1836L9.40759 15.2888C9.4929 15.3369 9.5617 15.4096 9.60496 15.4974C9.64142 15.5722 9.66053 15.6543 9.66088 15.7375C9.66142 15.9022 9.60014 16.0612 9.48917 16.1829C9.44246 16.2426 9.38342 16.2914 9.31609 16.3262C9.24876 16.3609 9.17472 16.3807 9.09903 16.3842ZM6.69443 14.6823L8.78719 15.9119C8.85759 15.9526 8.92469 15.9888 8.98917 16.0224C9.03118 16.0446 9.07979 16.0509 9.12608 16.0401C9.17237 16.0294 9.21322 16.0023 9.24114 15.9638C9.29873 15.9027 9.33033 15.8215 9.3293 15.7375C9.32891 15.7033 9.32081 15.6695 9.30561 15.6388C9.28959 15.6106 9.26555 15.5877 9.23653 15.573L7.22995 14.3724L6.69443 14.6823ZM6.37535 13.873L6.22009 13.9619C6.18718 13.9813 6.16083 14.0102 6.14443 14.0448C6.12361 14.0878 6.11282 14.1351 6.11285 14.1829C6.11324 14.2286 6.12404 14.2736 6.14443 14.3145C6.16336 14.3542 6.19297 14.388 6.22996 14.4119L6.4214 14.5237L6.37535 13.873ZM6.71877 14.0665L6.7339 14.2796L6.90627 14.179L6.71877 14.0665ZM6.71153 13.6796L7.23259 13.9901L9.24509 12.8244C9.27393 12.8073 9.29811 12.7833 9.31548 12.7546C9.32897 12.7331 9.33647 12.7083 9.33719 12.6829C9.33269 12.6032 9.29813 12.5282 9.24048 12.473C9.15166 12.3737 9.08785 12.3737 9.06745 12.3737C9.02994 12.3751 8.99297 12.3831 8.95824 12.3974C8.90003 12.4214 8.84391 12.4502 8.79048 12.4836L6.71153 13.6796Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M10.9549 17.2788C10.8531 17.2738 10.7558 17.2349 10.6786 17.1682C10.634 17.1357 10.5978 17.0928 10.5732 17.0434C10.5486 16.9939 10.5362 16.9393 10.5372 16.884C10.5379 16.8181 10.5539 16.7533 10.5839 16.6946L13.7891 10.1321C13.8233 10.062 13.8753 10.0021 13.9398 9.95837C13.9974 9.91694 14.0662 9.894 14.1372 9.89258C14.2372 9.89676 14.3329 9.93454 14.4089 9.99982C14.4536 10.033 14.4896 10.0766 14.5137 10.1268C14.5377 10.177 14.5492 10.2323 14.547 10.288C14.5462 10.3539 14.5302 10.4187 14.5003 10.4774L11.3029 17.0399C11.2695 17.1091 11.2193 17.1688 11.1569 17.2136C11.0981 17.256 11.0274 17.2788 10.9549 17.2788Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M10.9533 17.4419C10.8154 17.4371 10.6829 17.3864 10.577 17.2978C10.5125 17.2496 10.4603 17.1869 10.4245 17.1148C10.3887 17.0427 10.3704 16.9632 10.3711 16.8826C10.3724 16.791 10.3949 16.7009 10.4369 16.6195L13.6422 10.0609C13.6887 9.96447 13.76 9.88207 13.8487 9.82212C13.9489 9.75601 14.0681 9.725 14.1878 9.73393C14.3074 9.74285 14.4207 9.79123 14.5099 9.87146C14.5743 9.92043 14.6261 9.98393 14.6612 10.0568C14.6963 10.1296 14.7137 10.2097 14.7119 10.2905C14.7106 10.3822 14.6881 10.4723 14.6461 10.5537L11.4468 17.1123C11.4023 17.2069 11.3344 17.2887 11.2494 17.3498C11.1626 17.4103 11.0592 17.4425 10.9533 17.4419ZM14.1356 10.0603C14.0975 10.0609 14.0604 10.0733 14.0297 10.0958C13.9889 10.1234 13.9562 10.1613 13.9349 10.2057L10.7303 16.7649C10.7112 16.8012 10.7008 16.8416 10.7001 16.8826C10.6991 16.9129 10.7058 16.9429 10.7195 16.9699C10.7332 16.9969 10.7534 17.0201 10.7784 17.0373C10.8948 17.1267 10.9862 17.132 11.0606 17.0794C11.1008 17.0507 11.133 17.0122 11.154 16.9675L14.3507 10.4083C14.3697 10.3719 14.3801 10.3316 14.381 10.2905C14.383 10.26 14.3774 10.2295 14.3645 10.2018C14.3516 10.1741 14.3319 10.1501 14.3073 10.132C14.2592 10.0903 14.199 10.0652 14.1356 10.0603Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M15.998 16.2202C15.9405 16.2175 15.8842 16.2023 15.8332 16.1756C15.7822 16.1489 15.7376 16.1113 15.7026 16.0656C15.6177 15.9806 15.5683 15.8665 15.5645 15.7465C15.5638 15.6908 15.5789 15.6361 15.6079 15.5886C15.6415 15.5368 15.6865 15.4934 15.7395 15.4616L18.4789 13.8748L18.5342 14.6642L15.748 12.9978C15.6911 12.9662 15.6452 12.918 15.6164 12.8596C15.5907 12.807 15.5772 12.7492 15.577 12.6906C15.5755 12.5659 15.6227 12.4455 15.7086 12.355C15.7398 12.3137 15.7793 12.2793 15.8247 12.2541C15.87 12.229 15.9201 12.2136 15.9717 12.209C16.0368 12.2107 16.1005 12.2283 16.1572 12.2603C16.2226 12.2945 16.2923 12.3327 16.3664 12.3748L18.9322 13.8827C18.9939 13.9184 19.0434 13.9718 19.0743 14.036C19.1055 14.1014 19.1217 14.173 19.1217 14.2455C19.1217 14.318 19.1055 14.3896 19.0743 14.455C19.0436 14.5195 18.9941 14.5732 18.9322 14.609L16.3664 16.0853C16.3007 16.1221 16.2349 16.1511 16.177 16.18C16.121 16.2065 16.0599 16.2202 15.998 16.2202Z"
                                                  fill="#EA6404"
                                                ></path>
                                                <path
                                                  d="M15.9985 16.3842C15.9178 16.3818 15.8386 16.3619 15.7663 16.3259C15.6941 16.2899 15.6305 16.2387 15.58 16.1757C15.468 16.0603 15.4039 15.9068 15.4004 15.7461C15.3993 15.6604 15.4221 15.5761 15.4662 15.5026C15.5124 15.43 15.5745 15.3688 15.6478 15.3237L17.5096 14.2447L15.6603 13.1395C15.5746 13.0919 15.5057 13.0191 15.4629 12.9309C15.4265 12.8561 15.4074 12.774 15.407 12.6908C15.4063 12.5245 15.47 12.3645 15.5846 12.2441C15.6572 12.1469 15.7631 12.08 15.8821 12.0563C16.001 12.0326 16.1245 12.0538 16.2287 12.1158C16.2945 12.1493 16.3669 12.1888 16.4432 12.2322L19.009 13.7408C19.099 13.7928 19.1712 13.8708 19.2162 13.9645C19.2588 14.0523 19.2812 14.1485 19.282 14.2461C19.2814 14.3432 19.2589 14.439 19.2162 14.5263C19.1714 14.6209 19.0986 14.6994 19.0077 14.7513L16.4471 16.2283C16.3715 16.2691 16.305 16.3026 16.2439 16.3303C16.167 16.3661 16.0832 16.3845 15.9985 16.3842ZM17.8333 14.4382L15.8208 15.6039C15.792 15.6218 15.7673 15.6455 15.7485 15.6737C15.7352 15.6955 15.7286 15.7206 15.7294 15.7461C15.7335 15.8254 15.7676 15.9001 15.8248 15.9553C15.9142 16.0553 15.9781 16.0553 15.9985 16.0553C16.0351 16.055 16.0713 16.0467 16.1044 16.0309C16.159 16.0059 16.2189 15.9763 16.2833 15.9408L18.355 14.7493L17.8333 14.4382ZM18.6445 13.9072L18.6906 14.5559L18.8458 14.4664C18.8794 14.4475 18.9061 14.4185 18.9221 14.3836C18.9427 14.3404 18.9534 14.2932 18.9534 14.2454C18.9534 14.1976 18.9427 14.1504 18.9221 14.1072C18.906 14.0726 18.8793 14.044 18.8458 14.0257L18.6445 13.9072ZM18.1596 14.2493L18.3471 14.3618L18.332 14.1487L18.1596 14.2493ZM15.9669 12.3737C15.9109 12.3875 15.8615 12.4205 15.8274 12.4671C15.7982 12.4965 15.7752 12.5314 15.7596 12.5698C15.744 12.6082 15.7362 12.6494 15.7366 12.6908C15.737 12.725 15.7451 12.7588 15.7603 12.7895C15.7753 12.8173 15.7982 12.8402 15.8261 12.8553L17.8333 14.0559L18.3682 13.7461L16.2761 12.5164C16.2057 12.4757 16.1379 12.4395 16.0741 12.4059C16.0413 12.387 16.0046 12.376 15.9669 12.3737Z"
                                                  fill="#EA6404"
                                                ></path>
                                              </svg>
                                            </div>
                                            <div className="file-text">
                                              <span className="ext-name">
                                                {selectedfile?.name}
                                              </span>
                                              <strong>
                                                <span className="date-name">
                                                  01/09/2022
                                                </span>
                                                <span className="file-size">
                                                  {formatBytes(
                                                    selectedfile?.size
                                                  )}
                                                </span>
                                              </strong>
                                            </div>
                                          </div>
                                        </div>
                                        <div
                                          className={
                                            showProgress
                                              ? "right-progressbar"
                                              : "right-progressbar hide"
                                          }
                                        >
                                          <CustomProgressBar
                                            completed={fileUploadProgress}
                                            labelLineHeight="1px"
                                            labelSize="14px"
                                            width="100%"
                                            labelClassName="progressBarLabel"
                                            borderRadius="30px"
                                            labelAlignment="outside"
                                            labelColor="rgba(0,0,0,0.87)"
                                            height="10px"
                                            className="file_upload_progress"
                                            bgColor="#06B878"
                                            baseBgColor="#D1DEF0"
                                            ariaValuetext={fileUploadProgress}
                                            aria-label=""
                                            aria-valuenow={fileUploadProgress}
                                          />
                                        </div>
                                      </div>
                                    </div>
                                    <div>
                                        <div className="tooltip-container flex">
                                        <p>Notification will be sent to:
</p>
    <p
      tabindex={0} data-events={['focus']} data-eventsoff={['blur']}
      data-padding="10px 10px 10px 10px"
      data-place="right"
      data-tip
      data-for={"projectdetailCustomTaskfile"}
      aria-label="Tooltip"
      id={"vendorBidTooltipFocus"+"file"}
      className="m-0"
    >
      <svg
        className="svg-tooltip-icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
      </svg>

    </p>
    <ReactTooltip
      className="tooltip"
      id={"projectdetailCustomTaskfile"}
    >
      <div className="mar-bot6">
        <p>This can be edited by clicking Edit at the top of the page</p>

           </div>
    </ReactTooltip>
  </div>
                                        <p>{taskDetail?.creatorName}</p>
                                      </div>
                                  </div>
                                </div>
                                <div className="flex two-col justify-end">
                                  <button
                                    className={
                                       message === "" || fileSizeExceedStatus
                                        ? "disabled-data btn btn-bold"
                                        : "btn btn-bold"
                                    }
                                    type="submit"
                                    onClick={() => setIsFileAttached(true)}
                                  >
                                    Submit
                                  </button>
                                  <button
                                    type="button"
                                    className="blue-btn"
                                    onClick={cancelChat}
                                  >
                                    Cancel
                                  </button>
                                </div>
                              </form>
                            </div>
                          </div>
                        </td>
                      ) : (
                        Constants.BLANK
                      )}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </>
        ) : showTaskEdit ? (
          <>
            <div className="campaign_details-task-create-form">
              <EditCustomTaskForm
                id={workspaceId}
                funct={() => showTaskDetail(taskDetail?.id)}
                taskLangs={langs}
                taskDetail={taskDetail}
              />
            </div>
          </>
        ) : !showCreateTask ? (
          <div className="campaign_details-task campaign-form">
            <div className="projects-heading">
              <h5>{translate("task_campaign.campaign_tasks")}</h5>
              <div className="btn-wrap">
                <div className="filter" id="filter">
                  <button
                    id="activeId"
                    className="dashboard-btn filterTask"
                    onClick={filterToggle}
                    onKeyDown={(e) => handleEscFocus(e)}
                    aria-expanded="false"
                  >
                    <span className="filter-icon">
                      <svg
                        width="19"
                        height="14"
                        viewBox="0 0 19 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M18.5627 4.00922H7.56233C7.32684 4.00922 7.125 3.64384 7.125 3.21755C7.125 2.79127 7.32684 2.42589 7.56233 2.42589H18.5627C18.7982 2.42589 19 2.79127 19 3.21755C19 3.64384 18.7982 4.00922 18.5627 4.00922Z"
                          fill="#1D4ED8"
                        ></path>
                        <path
                          d="M2.99075 3.649H0.607496C0.280383 3.649 0 3.36861 0 3.0415C0 2.71439 0.280383 2.43401 0.607496 2.43401H2.99075C3.31786 2.43401 3.59824 2.71439 3.59824 3.0415C3.59824 3.36861 3.36459 3.649 2.99075 3.649Z"
                          fill="#1D4ED8"
                        ></path>
                        <path
                          d="M5.37429 6.03238C3.73873 6.03238 2.38354 4.6772 2.38354 3.04164C2.38354 1.40607 3.73873 0.0508881 5.37429 0.0508881C7.00986 0.0508881 8.36504 1.40607 8.36504 3.04164C8.36504 4.6772 7.05659 6.03238 5.37429 6.03238ZM5.37429 1.26588C4.39295 1.26588 3.59854 2.0603 3.59854 3.04164C3.59854 4.02298 4.39295 4.81739 5.37429 4.81739C6.35563 4.81739 7.15005 4.02298 7.15005 3.04164C7.15005 2.0603 6.35563 1.26588 5.37429 1.26588Z"
                          fill="#1D4ED8"
                        ></path>
                        <path
                          d="M0.437329 9.9906L11.4377 9.9906C11.6732 9.9906 11.875 10.356 11.875 10.7823C11.875 11.2085 11.6732 11.5739 11.4377 11.5739L0.437329 11.5739C0.201844 11.5739 -3.19429e-08 11.2085 -6.92097e-08 10.7823C-1.06476e-07 10.356 0.201844 9.9906 0.437329 9.9906Z"
                          fill="#1D4ED8"
                        ></path>
                        <path
                          d="M16.0093 10.3508L18.3925 10.3508C18.7196 10.3508 19 10.6312 19 10.9583C19 11.2854 18.7196 11.5658 18.3925 11.5658L16.0093 11.5658C15.6821 11.5658 15.4018 11.2854 15.4018 10.9583C15.4018 10.6312 15.6354 10.3508 16.0093 10.3508Z"
                          fill="#1D4ED8"
                        ></path>
                        <path
                          d="M13.6257 7.96743C15.2613 7.96743 16.6165 9.32262 16.6165 10.9582C16.6165 12.5937 15.2613 13.9489 13.6257 13.9489C11.9901 13.9489 10.635 12.5937 10.635 10.9582C10.635 9.32262 11.9434 7.96743 13.6257 7.96743ZM13.6257 12.7339C14.607 12.7339 15.4015 11.9395 15.4015 10.9582C15.4015 9.97684 14.607 9.18242 13.6257 9.18242C12.6444 9.18242 11.8499 9.97684 11.85 10.9582C11.85 11.9395 12.6444 12.7339 13.6257 12.7339Z"
                          fill="#1D4ED8"
                        ></path>
                      </svg>
                    </span>{" "}
                    {translate("task_campaign.filters")}
                  </button>
                  <div
                    id="filterBtn2"
                    className="filter-content flex local-filter"
                    onKeyDown={(e) => handleModalFocus(e)}
                  >
                    <div className="flex wrap-dropdown">
                      <div className="global-dropdown-block flex-center">
                        <label> {translate("task_campaign.project")}</label>
                        <div className="global-dropdown-select">
                          <Select
                            className="global-dropdown-select firstOutFocus"
                            classNamePrefix="cw"
                            value={projectFilter.filter(function (option) {
                              return option.value === selectedProjectStatus;
                            })}
                            aria-label="Project"
                            options={
                              projectFilter.length === 1
                                ? projectFilter.slice(1)
                                : projectFilter
                            }
                            onChange={(e) => handleProjectStatusChange(e)}
                          />
                        </div>
                      </div>
                      <div className="global-dropdown-block flex-center">
                        <label>{translate("task_campaign.task_status")}</label>

                        <div className="global-dropdown-select">
                          <Select
                            className="global-dropdown-select"
                            classNamePrefix="cw"
                            value={taskStatus.filter(function (option) {
                              return option.value === selectedTaskStatus;
                            })}
                            aria-label="Task status"
                            options={taskStatus}
                            onChange={(e) => handleTaskStatusChange(e)}
                          />
                        </div>
                      </div>
                      <div className="global-dropdown-block flex-center">
                        <label>{translate("task_campaign.type")}</label>
                        <div className="global-dropdown-select">
                          <Select
                            className="global-dropdown-select"
                            classNamePrefix="cw"
                            value={type.filter(function (option) {
                              return option.value === selectedTypeStatus;
                            })}
                            aria-label="Type"
                            options={type}
                            onChange={(e) => handleTypeStatusChange(e)}
                          />
                        </div>
                      </div>
                      <div className="global-dropdown-block flex-center">
                        <label>{translate("project_page.assigned_to")}</label>
                        <div className="global-dropdown-select">
                          <Select
                            className="global-dropdown-select"
                            classNamePrefix="cw"
                            value={assignees.filter(function (option) {
                              return option.value === selectedAssignee;
                            })}
                            aria-label="Assigned to"
                            options={assignees}
                            onChange={(e) => handleAssigneeChange(e)}
                          />
                        </div>
                      </div>
                      <div className="global-dropdown-block global-multidropdown-check flex-center">
                        <label>{translate("task_campaign.language")}</label>
                        <div className="global-dropdown-select language-dropdown">
                          <ReactMultiSelect
                            ref={multiSelectRef}
                            value={selectedLanguages}
                            option={languageFilter}
                            callback={handleLanguageChange}
                            ariaLabel={"Language"}
                            placeholder={"Select "}
                            inputChange={handleInputChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {custBootstrapDataRedux?.roleSet?.customerType &&
                custBootstrapDataRedux?.permissions?.CREATE_TASK &&
                campaignWorkspace?.editableByContextUser &&
                custBootstrapDataRedux?.features?.CUSTOM_TASK ? (
                  <button
                    className="dashboard-btn"
                    onClick={() => toggleCreateTask(true)}
                  >
                    {" "}
                    {translate("task_campaign.create_campaign_task")}
                  </button>
                ) : (
                  Constants.BLANK
                )}
              </div>
            </div>
            <div className="task-content">
              <div className="datatable-block">
                <DataTable
                  keyField="id"
                  columns={columns}
                  data={tasks}
                  defaultSortFieldId={1}
                  responsive
                  onSort={handleSort}
                  striped
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  onChangeRowsPerPage={handlePerRowsChange}
                  paginationRowsPerPageOptions={[10, 20, 40, 50, 100, 200]}
                  onChangePage={handlePageChange}
                  progressPending={pending}
                  noDataComponent={noDataFoundComponent()}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="campaign_details-task-create-form">
            <div className="projects-heading">
              <h5>{translate("task_campaign.create_custom_task")}</h5>
            </div>
            <CustomTaskForm id={workspaceId} funct={toogleFromList} />
          </div>
        )}
        {historyPopup ? (
          <div
            id="modelPopup"
            className="lightbox-panel task-popup bid-extended"
          >
            <div className="inner-lightbox-panel">
              <div className="modal-header flex">
                <strong>Task History</strong>
                <button
                  className="close"
                  aria-label="close right popup"
                  onClick={hideModel}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                    fill="none"
                  >
                    <path
                      d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                      fill="white"
                    ></path>
                    <path
                      d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                      fill="white"
                    ></path>
                  </svg>
                </button>
              </div>
              <div className="lightbox-content task-form-content">
                {recentTaskActivity?.events?.map((activity, index) => {
                  return (
                    <div key={index}>
                      {compareDateWithCurrent(
                        activity.createdDate,
                        Constants.DATE_COMPARE_FORMAT
                      ) ? (
                        <div className="activity-feed-inner">
                          {index === 0 ? (
                            <span
                              className="title"
                              style={{ marginBottom: "8px", fontWeight: "600" }}
                            >
                              {" "}
                              Today
                            </span>
                          ) : (
                            ""
                          )}
                          <ul className="activity-feed-table">
                            <li>
                              <span>
                                {dateFormat(
                                  activity.createdDate,
                                  Constants.HOUR_MIN_AM_PM
                                )}
                                <p>
                                  {activity.output.replace(
                                    /<a.*?>.*?<\/a>/gi,
                                    ""
                                  )}
                                </p>
                              </span>
                            </li>
                          </ul>
                        </div>
                      ) : (
                        <div className="activity-feed-inner">
                          {index !== 0 ? (
                            dateFormat(
                              recentTaskActivity.events[index - 1]?.createdDate,
                              Constants.DATE_COMPARE_FORMAT
                            ) !==
                            dateFormat(
                              recentTaskActivity.events[index].createdDate,
                              Constants.DATE_COMPARE_FORMAT
                            ) ? (
                              <span
                                className="title"
                                style={{
                                  marginBottom: "8px",
                                  fontWeight: "600",
                                }}
                              >
                                {dateFormat(
                                  activity.createdDate,
                                  Constants.DATE_COMPARE_FORMAT
                                )}
                              </span>
                            ) : (
                              ""
                            )
                          ) : (
                            <span className="title">
                              {dateFormat(
                                activity.createdDate,
                                Constants.DATE_COMPARE_FORMAT
                              )}
                            </span>
                          )}
                          <ul className="activity-feed-table">
                            <li>
                              <span
                                className={
                                  index !== 0
                                    ? dateFormat(
                                        recentTaskActivity.events[index - 1]
                                          ?.createdDate,
                                        Constants.DATE_COMPARE_FORMAT
                                      ) !==
                                      dateFormat(
                                        recentTaskActivity.events[index]
                                          .createdDate,
                                        Constants.DATE_COMPARE_FORMAT
                                      )
                                      ? ""
                                      : ""
                                    : ""
                                }
                              >
                                {dateFormat(
                                  activity.createdDate,
                                  Constants.HOUR_MIN_AM_PM
                                )}
                              </span>
                              <p>
                                {" "}
                                {activity.output.replace(
                                  /<a.*?>.*?<\/a>/gi,
                                  ""
                                )}{" "}
                              </p>
                            </li>
                          </ul>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <div className="modal-footer flex">
                <button className="btn btn-bold" onClick={hideModel}>
                  Close
                </button>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
}
